module.exports = __webpack_public_path__ + "media/images/logo_1024-e973fe71.png";